import { OrmRegister } from "@natiwi/core/models/register";

export abstract class OrmInformationRegister extends OrmRegister {

    constructor() {
        super();
    }

}